import React, { FC, SyntheticEvent, useEffect, useState } from 'react';
import amplitude from 'amplitude-js';

import { AnswerTypes } from 'types';

import Header from 'components/Header';
import Button from 'components/Button';
import Input from 'components/Input';

import sendUserData from 'api/sendUserData';
import sendAnalyticsEvent from 'utils/sendAnalyticsEvent';
import getQuizData from 'api/getQuizData';

const Email: FC<AnswerTypes> = (props) => {
    const { title, logoUrl, text, buttonText, image, handleSwitchToNextScreen, logoLink } = props;

    const [value, setValue] = useState('');
    const [isSendAnalytic, setIsSendAnalytic] = useState(false);

    const userAnswers = sessionStorage.getItem('userAnswers');
    const localQuizId = sessionStorage.getItem('quizId');

    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const inputValue = event.target.value;

        setValue(inputValue);
    };

    const handleClick = async (e: SyntheticEvent<HTMLFormElement, Event>) => {
        e.preventDefault();
        const identify = new amplitude.Identify().set('user_email', value);

        amplitude.getInstance().identify(identify); // send the Identify call
        sendAnalyticsEvent({
            eventName: 'email_page_completed',
            data: { email: value },
        });

        // Send user email to GTM
        if (typeof window !== 'undefined' && window.dataLayer) {
            window.dataLayer.push({
                event: 'user_email_submitted',
                user_email: value,
                funnel_name: localQuizId,
            });
        }

        localStorage.setItem('userEmail', value);

        // Check if this is a user_profile quiz
        const quizData = await getQuizData(localQuizId || undefined);
        console.log('🔍 Quiz data structure:', JSON.stringify(quizData, null, 2));
        
        // Try different possible paths to quiz_type
        const quizType = quizData?.[0]?.data?.quiz_type || 
                         quizData?.[0]?.quiz_type || 
                         quizData?.quiz_type ||
                         quizData?.data?.quiz_type;
        
        console.log('🎯 Quiz type detected:', quizType);

        if (quizType === 'user_profile') {
            // Send to new API endpoint for user profile quizzes
            console.log('📝 Detected user_profile quiz, submitting to /api/submit-quiz');
            console.log('📧 Email:', value);
            console.log('🎯 Quiz name:', localQuizId);
            
            try {
                const payload = {
                    email: value,
                    answers: JSON.parse(userAnswers || ''),
                    quest_name: localQuizId,
                };
                
                console.log('📤 Sending payload:', payload);
                
                const response = await fetch('/api/submit-quiz', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(payload),
                });
                
                console.log('📥 Response status:', response.status);
                
                if (!response.ok) {
                    throw new Error(`API returned ${response.status}`);
                }
                
                const result = await response.json();
                console.log('✅ Quiz submission result:', result);
                
                if (result.success && result.profile_built) {
                    console.log('🎉 Profile built successfully! Redirecting to dashboard...');
                    // Data is saved, safe to redirect
                    setTimeout(() => {
                        window.location.href = '/dashboard';
                    }, 500);
                } else {
                    console.warn('⚠️ Profile not built, user might not exist yet');
                    // Go to thank page instead
                    handleSwitchToNextScreen();
                }
            } catch (error) {
                console.error('❌ Error submitting user profile quiz:', error);
                // Show error to user or go to thank page
                alert('There was an error processing your quiz. Please try again or contact support.');
                handleSwitchToNextScreen();
            }
        } else {
            // Use existing endpoint for regular quizzes
            sendUserData({ email: value, answers: JSON.parse(userAnswers || ''), quest_name: localQuizId }).then(() => {
                handleSwitchToNextScreen();
            });
        }
    };

    useEffect(() => {
        if (!isSendAnalytic) {
            sendAnalyticsEvent({
                eventName: 'email_page_shown',
                data: {},
            });
            setIsSendAnalytic(true);
        }
    }, [isSendAnalytic]);

    return (
        <section className="email" style={{ backgroundImage: `url(${image}` }}>
            <Header logoUrl={logoUrl} isHiddenProgress logoLink={logoLink} />
            <div className="email__wrapper">
                <div className="email__wrap">
                    {title && <h2 dangerouslySetInnerHTML={{ __html: title }} className="email__title" />}
                    {text && <p dangerouslySetInnerHTML={{ __html: text }} className="email__text" />}
                    <form onSubmit={handleClick}>
                        <div className="email__input-wrap">
                            <Input value={value} onChange={onChange} placeholder="Enter your email" />
                        </div>
                        <Button type="submit" text={buttonText} />
                    </form>
                </div>
            </div>
        </section>
    );
};

export default Email;
